import FormatCurrency from 'components/Common/FormatCurrency'
import Group from 'components/utils/Group'
import { formatSaleUnitLabel } from 'hooks/useSaleUnitFormatting'
import Caption from 'LuxKit/Typography/Caption'
import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'

type InheritedFormatCurrencyProps = Pick<ComponentProps<typeof FormatCurrency>, 'signDisplay'>

interface Props extends InheritedFormatCurrencyProps, Utils.PropsWithDataAttributes {
  altPrice: number
  saleUnit?: string
  className?: string
}

function MaldivesWasPriceRow(props: Props) {
  const {
    altPrice,
    saleUnit,
    signDisplay,
    className,
    ...rest
  } = props
  const intl = useIntl()
  const saleUnitLabel = formatSaleUnitLabel(intl, saleUnit, { withLeadingSlash: true })
  const wasLabel = intl.formatMessage({
    id: 'LBSpbDtOPeY_frIGIka0',
    defaultMessage: 'Was',
  })

  return <Group
    {...rest}
    className={className}
    direction="horizontal"
    verticalAlign="center"
    gap={4}
  >
    <Caption variant="medium" colour="light-foreground-alt" weight="normal">
      {wasLabel}
    </Caption>
    <Caption variant="medium" colour="light-foreground-alt" weight="normal" strikeThrough>
      <FormatCurrency signDisplay={signDisplay} value={altPrice} format="roundedDollar" />
    </Caption>
    {!!saleUnitLabel && <Caption variant="medium" colour="light-foreground-alt" weight="normal" strikeThrough>
      {saleUnitLabel}
    </Caption>}
  </Group>
}

export default MaldivesWasPriceRow
